import React from 'react';

function ModelSelector({ models = [], selectedModelId, onSelect }) {
  return (
    <div className="model-selector">
      <label htmlFor="model-select">Model</label>
      <select
        id="model-select"
        onChange={(event) => onSelect(event.target.value)}
        value={selectedModelId}
      >
        {models.map((model) => (
          <option key={model.id} value={model.id}>{model.label}</option>
        ))}
      </select>
    </div>
  );
}

export default ModelSelector;
